import { render, staticRenderFns } from "./performance-desc.vue?vue&type=template&id=3460269a&scoped=true"
import script from "./performance-desc.vue?vue&type=script&lang=ts"
export * from "./performance-desc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460269a",
  null
  
)

export default component.exports